import React from 'react'
import formheadmobilStyle from './formheadMobil.module.css'
import { Link } from 'react-router-dom';
require('typeface-poppins')


export default function FormheadMobil() {
    return (
        <>
            <div className={`${formheadmobilStyle.topInfo}`}>
                <div className={`${formheadmobilStyle.projectnavMobil} d-flex flex-wrap align-items-center`}>
                    <Link to="/" className={formheadmobilStyle.projectnavTitle}> Back to Search Results </Link>
                </div>
            </div>
        </>
    )
}


